import { render } from "./ModalElectricityMeterExtended.vue?vue&type=template&id=535a0788&scoped=true"
import script from "./ModalElectricityMeterExtended.vue?vue&type=script&lang=js"
export * from "./ModalElectricityMeterExtended.vue?vue&type=script&lang=js"

import "./ModalElectricityMeterExtended.vue?vue&type=style&index=0&id=535a0788&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535a0788"]])

export default __exports__